import React, { useState } from 'react';

export default function (props) {
    const { slide = { burl: '', index: -199 }, focused, imgClick } = props;
    const [imageError, setImageError] = useState(false);
    const loading = !slide.burl;
    // image that says "Upload an image to get started"
    const getStartedURL = 'https://i.imgur.com/BdbjnMF.jpg';
    // image that says "Grabbing your presentation. Just a sec"
    const loadingPresentation = 'https://i.imgur.com/FnSf0dL.jpg';
    // image that is just gray
    const loadingGray =
        'https://www.virtualdatapartners.com/wp-content/uploads/2016/06/Gray-background-3.jpg';
    // Fallback: data URL for a simple gray placeholder
    const fallbackGray =
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect width="400" height="300" fill="%23aaa"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23fff" font-size="20"%3ELoading...%3C/text%3E%3C/svg%3E';

    let image = slide.burl;

    if (loading && slide.index > -1) {
        if (focused) {
            image = loadingPresentation;
        } else {
            image = imageError ? fallbackGray : loadingGray;
        }
    } else if (slide.index < 0) {
        image = getStartedURL;
    }

    const styles = props.style || {};

    // The flex-start alignment is to help make the behavior of chrome and safari alike.
    // Makes 'height: auto' within a flex container put the image at
    // the start of the container and not behave like 'height: 100%' (in safari)
    return (
        <img
            key={slide.index}
            style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                ...styles
            }}
            alt={`img-${slide.index}`}
            src={image}
            onMouseDown={(e) => e.preventDefault()}
            onError={() => {
                console.error('Failed to load image for slide:', slide);
                setImageError(true);
            }}
            onClick={({ target }) => {
                if (imgClick) {
                    imgClick(target);
                }
            }}></img>
    );
}
